import { useQuery, useMutation } from "@tanstack/react-query";
import api from "../axios-client";
import { queryClient } from "../query-client";

export interface ErrorDefinition {
    id: number;
    code: string;
    title: string;
    description: string;
    number: number;
}

export const useGetAllErrors = (modelId?: string) =>
    useQuery<ErrorDefinition[]>({
        queryKey: ["error-definitions", modelId],
        queryFn: async () => {
            const params = modelId ? { modelId } : {};
            const response = await api.get("/api/v1/errors", { params });
            return response.data.data;
        },
        retry: false,
        staleTime: 1000 * 60 * 60,
    });

export const useCreateError = (modelId?: string) =>
    useMutation({
        mutationFn: async (data: { code: string; title: string; description: string; number: number }) => {
            const body = modelId ? { ...data, device_model_id: modelId } : data;
            const response = await api.post("/api/v1/errors", body);
            return response.data.data;
        },
        onSuccess: () => {
            queryClient.refetchQueries({ queryKey: ["error-definitions", modelId] });
        },
    });

export const useUpdateError = (modelId?: string) =>
    useMutation({
        mutationFn: async ({ id, data }: { id: number; data: { code: string; title: string; description: string; number: number } }) => {
            const response = await api.put(`/api/v1/errors/${id}`, data);
            return response.data.data;
        },
        onSuccess: () => {
            queryClient.refetchQueries({ queryKey: ["error-definitions", modelId] });
        },
    });

export const useDeleteError = (modelId?: string) =>
    useMutation({
        mutationFn: async (id: number) => {
            const response = await api.delete(`/api/v1/errors/${id}`);
            return response.data.data;
        },
        onSuccess: () => {
            queryClient.refetchQueries({ queryKey: ["error-definitions", modelId] });
        },
    });
